import { Component, OnInit, OnChanges, Input, ViewChild, TemplateRef } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import * as moment from 'moment';

@Component({
    selector: 'sharyx-whatsapp-response-tab',
    templateUrl: './sharyxWhatsappResponse.component.html',
})
export class SharyxWhatsappResponseComponent implements OnInit, OnChanges {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('interestedTemplate') interestedTemplate: TemplateRef<any>;
    @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    isLoadMask: Promise<any>;
    loadingIndicator = true;
    suppressPaging = false;
    scrollTimeout: any;

    filterData: any = {
        search_data: '',
        from_date: new Date(),
        to_date: new Date(),
    };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'w.received_at',
        orderDir: 'desc'
    };

    columns = [];
    reportData: any[] = [];
    summaryStats: any = { total: 0, interested: 0, not_interested: 0, visit_confirmed: 0 };

    selectedRow: any = null;
    chatMessages: any[] = [];
    bsModalRef: BsModalRef;

    constructor(
        private http: Http,
        private toasterService: ToasterService,
        private modalService: BsModalService
    ) {}

    ngOnInit() {
        this.getList();
        this.loadSummaryStats();
    }

    ngOnChanges() {
        if (this.active) {
            this.getList();
            this.loadSummaryStats();
        }
    }

    loadSummaryStats() {
        const p = this.buildParams(0, 0);
        const options = new RequestOptions({ headers: this.headers, search: p });
        this.http.get('api/aiCallWebhook/getWhatsappSummary', options)
            .toPromise()
            .then((res: any) => {
                const body = res.json();
                if (body.success && body.data) { this.summaryStats = body.data; }
            })
            .catch(() => {});
    }

    pageCallback(pageInfo: any) {
        this.page.offset = pageInfo.offset !== undefined ? pageInfo.offset : (pageInfo.page - 1);
        if (!this.suppressPaging) { this.getList(); }
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    sortCallback(sortInfo: any) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy  = sortInfo.sorts[0].prop;
        this.getList();
    }

    onChangePageSize(limit: number) {
        this.page.limit = limit;
        this.getList();
    }

    applyFilter() {
        this.page.offset = 0;
        this.filterPanel.close();
        this.getList();
        this.loadSummaryStats();
    }

    clearFilter() {
        this.filterData = { search_data: '', from_date: new Date(), to_date: new Date() };
        this.applyFilter();
    }

    buildParams(start: number, limit: number): URLSearchParams {
        const p = new URLSearchParams();
        p.set('start', `${start}`);
        p.set('limit', `${limit}`);
        p.set('orderColumn', this.page.orderBy);
        p.set('orderDir', this.page.orderDir);
        p.set('search_data', this.filterData.search_data || '');
        if (this.filterData.from_date) { p.set('from_date', moment(this.filterData.from_date).format('YYYY-MM-DD')); }
        if (this.filterData.to_date)   { p.set('to_date',   moment(this.filterData.to_date).format('YYYY-MM-DD')); }
        return p;
    }

    getList() {
        const options = new RequestOptions({ headers: this.headers, search: this.buildParams(this.page.offset * this.page.limit, this.page.limit) });
        this.isLoadMask = this.http.get('api/aiCallWebhook/getWhatsappList', options)
            .toPromise()
            .then((res: any) => {
                const body = res.json();
                this.loadingIndicator = false;
                this.page.count = body.totCnt || 0;
                this.reportData  = body.data  || [];
                if (body.columns) { this.columns = this.mapColumns(body.columns); }
            })
            .catch(() => {
                this.loadingIndicator = false;
                this.toasterService.pop('error', 'Error', 'Failed to load WhatsApp response data');
            });
    }

    private mapColumns(cols: any[]): any[] {
        const tplMap: any = {
            sno:       this.snoTemplate,
            interested:this.interestedTemplate,
            id:        this.actionTemplate,
        };
        return cols.map((c: any) => {
            const def: any = { name: c.name, prop: c.prop, width: c.width, minWidth: c.width, maxWidth: c.width, sortable: !!c.sortable };
            if (tplMap[c.prop]) { def.cellTemplate = tplMap[c.prop]; }
            return def;
        });
    }

    viewConversation(row: any, tpl: TemplateRef<any>) {
        this.selectedRow  = row;
        this.chatMessages = this.buildChatMessages(row);
        this.bsModalRef   = this.modalService.show(tpl, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg'
        });
    }

    buildChatMessages(row: any): any[] {
        let sent: any = null;
        let received: any = null;
        try { sent     = JSON.parse(row.customer_sent     || '[]'); } catch (e) {}
        try { received = JSON.parse(row.customer_received || '[]'); } catch (e) {}
        const msgs: any[] = [];

        // Array format: customer_sent = bot messages, customer_received = customer replies
        if (Array.isArray(sent) || Array.isArray(received)) {
            const s = Array.isArray(sent)     ? sent     : [];
            const r = Array.isArray(received) ? received : [];
            const maxLen = Math.max(s.length, r.length);
            for (let i = 0; i < maxLen; i++) {
                if (i < s.length) {
                    const m = s[i];
                    msgs.push({ side: 'bot', text: typeof m === 'string' ? m : (m.text || m.message || JSON.stringify(m)) });
                }
                if (i < r.length) {
                    const m = r[i];
                    msgs.push({ side: 'customer', text: typeof m === 'string' ? m : (m.text || m.message || JSON.stringify(m)) });
                }
            }
            return msgs;
        }

        // Object format: customer_received = bot questions, customer_sent = customer answers
        if (sent && received && typeof sent === 'object' && typeof received === 'object') {
            const flow = [
                { bot: 'service_question',      cust: 'service' },
                { bot: 'age_question',           cust: 'age_reply' },
                { bot: 'date_question',          cust: 'date_choice' },
                { bot: 'time_question',          cust: 'time_slot' },
                { bot: 'confirmation_message',   cust: 'confirmation' },
                { bot: 'final_message',          cust: null },
            ];
            flow.forEach(pair => {
                if (received[pair.bot]) { msgs.push({ side: 'bot',      text: received[pair.bot] }); }
                if (pair.cust && sent[pair.cust]) { msgs.push({ side: 'customer', text: sent[pair.cust] }); }
            });
        }
        return msgs;
    }

    closeModal() {
        if (this.bsModalRef) { this.bsModalRef.hide(); }
    }

    downloadExcel() {
        const p = this.buildParams(0, 9999);
        window.open(`api/aiCallWebhook/exportWhatsapp?${p.toString()}`, '_blank');
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/sharyxWhatsappResponse/sharyxWhatsappResponse.component.ts